import React from 'react';
import MainBanner from '../Pricing/MainBanner';
import PricingCardOne from '../Pricing/PricingCardOne';
import Footer from '../Common/Footer';
import {useHistory} from'react-router-dom';
 
const Home =()=> {

    
        return (
            <React.Fragment>
                <MainBanner />
                <PricingCardOne />
                <Footer />
            </React.Fragment>
        );
   
}
 
export default Home;